// ThemeContext.js — thin shim over the ambient design engine.
// Legacy consumers read `darkMode`/`toggleDarkMode`; the palette itself
// lives in design/DesignContext (time-of-day + weather aware).
import { ThemeProvider } from '@mui/material/styles';
import React, { createContext, useContext, useMemo } from 'react';
import { useDesign } from '../design/DesignContext';
import { buildAmbientMuiTheme } from '../theme/ambientMui';

const ThemeContext = createContext();

export const useThemeContext = () => useContext(ThemeContext);

const ThemeContextProvider = ({ children }) => {
  const { resolvedMode, vars, setModePref } = useDesign();
  const darkMode = resolvedMode === 'dark';

  const theme = useMemo(
    () => buildAmbientMuiTheme(vars, resolvedMode),
    [vars, resolvedMode]
  );

  const toggleDarkMode = () => {
    setModePref(darkMode ? 'light' : 'dark');
  };

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode, theme }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeContextProvider;
